import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import { ButtonClickEvent } from 'ui/base/types';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';

import { CountryCode, getLocalNameByCode } from 'services/base/countries';

import baseStyles from './location_entry.module.css';

import 'flag-icons/css/flag-icons.min.css';


type LocationEntryStyles = {
  plainContainer: string;
  clickableContainer: string;
  iconContainer: string;
  detailContainer: string;
  detailText: string;
  bareButton: string;
  removeIcon: string;
};

const themedStyles: ThemedStyles<LocationEntryStyles> = {
  [Theme.DAYLIGHT]: {
    plainContainer: baseStyles.plainContainer,
    clickableContainer: baseStyles.clickableContainer,
    iconContainer: baseStyles.iconContainer,
    detailContainer: baseStyles.detailContainer,
    detailText: baseStyles.detailText,
    bareButton: baseStyles.bareButton,
    removeIcon: baseStyles.midnightRemoveIcon,
  },
  [Theme.MIDNIGHT]: {
    plainContainer: baseStyles.plainContainer,
    clickableContainer: baseStyles.clickableContainer,
    iconContainer: baseStyles.iconContainer,
    detailContainer: baseStyles.detailContainer,
    detailText: baseStyles.detailText,
    bareButton: baseStyles.bareButton,
    removeIcon: baseStyles.midnightRemoveIcon,
  },
};

type RemovableLocationEntryProps = {
  code: CountryCode;
  onRemoveClick: (event: ButtonClickEvent) => void;
};

export const RemovableLocationEntry = observer(({ code, onRemoveClick }: RemovableLocationEntryProps) => {
  const styles = useStyles(themedStyles);

  return (
    <div className={styles.plainContainer}>
      <div className={styles.iconContainer}>
        <span className={classNames('fi', `fi-${code.toLowerCase()}`)}></span>
      </div>
      <div className={styles.detailContainer}>
        <div className={styles.detailText}>
          {getLocalNameByCode(code)}
        </div>
        <button type='button' className={styles.bareButton} onClick={onRemoveClick}>
          <div className={styles.removeIcon}/>
        </button>
      </div>
    </div>
  );
});

export type SearchLocationEntryProps = {
  data: CountryCode;
  onSelect: () => void;
};

export const SearchLocationEntry = observer(({ data: code, onSelect }: SearchLocationEntryProps) => {
  const styles = useStyles(themedStyles);

  return (
    <div className={styles.clickableContainer} onClick={onSelect}>
      <div className={styles.iconContainer}>
        <span className={classNames('fi', `fi-${code.toLowerCase()}`)}></span>
      </div>
      <div className={styles.detailContainer}>
        <div className={styles.detailText}>
          {getLocalNameByCode(code)}
        </div>
      </div>
    </div>
  );
});

export type PlainLocationEntryProps = {
  code: CountryCode;
};
export const PlainLocationFilter = observer(({ code }: PlainLocationEntryProps) => {
  const styles = useStyles(themedStyles);

  return (
    <div className={styles.plainContainer}>
      <div className={styles.iconContainer}>
        <span className={classNames('fi', `fi-${code.toLowerCase()}`)}></span>
      </div>
      <div className={styles.detailContainer}>
        <div className={styles.detailText}>
          {getLocalNameByCode(code)}
        </div>
      </div>
    </div>
  );
});
